import styled from 'styled-components';

export const LanguageSelectWrapper = styled.div`
  margin-bottom: 4px;
`;
